import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class GetAssignableRoles extends BaseAdapter<string[]> implements AdapterInterface {
  rawResponse: string[];

  async adaptResponse(): Promise<{ label: string; value: string }[]> {
    await this.fetchApiResponse('/api/organisation/roles/assignable', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): { label: string; value: string }[] {
    return this.rawResponse.map((role) => ({ label: role, value: role }));
  }
}
